import React, { useRef, useState } from "react";
import { DatePicker } from "antd";
import type { RangePickerProps } from "antd/es/date-picker";
import useVisibilityFocus from "../../hooks/useVisibilityFocus";

const FilterDateRangePicker = (props: RangePickerProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);

  useVisibilityFocus(
    () => wrapperRef.current,
    () => setOpen(true),
  );

  return (
    <div ref={wrapperRef}>
      <DatePicker.RangePicker open={open} onOpenChange={setOpen} {...props} />
    </div>
  );
};

export default FilterDateRangePicker;
